import JwtBaseClient from './JwtBaseClient';

/**
 * @class RewardsClient
 *
 * @description API wrapper for Loyalty API
 */
class RewardsClient extends JwtBaseClient {
  constructor() {
    super(import.meta.env.VITE_REWARDS_URI);
  }

  async isRewardsProgramEligible(dealerId) {
    try {
      const response = await this.get(`/api/loyalty/eligibility/${dealerId}`);
      return response.data.eligible;
    } catch (error) {
      return false;
    }
  }

  async loyaltyProgramStatus(dealerId) {
    try {
      const response = await this.get(`/api/loyalty/opt-in/${dealerId}/status`);
      return response.data.enroll;
    } catch (error) {
      return false;
    }
  }

  async joinLoyaltyProgram(dealerId) {
    const response = await this.post(`/api/loyalty/opt-in/${dealerId}`);
    return response.data.enroll;
  }
}

export default RewardsClient;
